var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-bar',{attrs:{"app-list":_vm.appList,"change-route":_vm.changeRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }